import jwtAuthAxios from "./auth/jwtAuth";

// Asistencia del equipo de Kargotools. Ver hermes-backend app/controllers/api/v1/attendance_controller.rb.
const attendanceServices = {};

const query = (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && String(value) !== "") search.set(key, String(value));
    });
    const text = search.toString();
    return text ? `?${text}` : "";
};

attendanceServices.report = async (params) => (await jwtAuthAxios.get(`/attendance${query(params)}`)).data;
attendanceServices.downloadXlsx = async (params) => (await jwtAuthAxios.get(`/attendance.xlsx${query(params)}`, {
    responseType: "arraybuffer",
    headers: { Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
})).data;
attendanceServices.checkIn = async (note) => (await jwtAuthAxios.post("/attendance/check_in", { note })).data;
attendanceServices.checkOut = async (note) => (await jwtAuthAxios.post("/attendance/check_out", { note })).data;
// Tramo a mano: { user_id, date: "YYYY-MM-DD", check_in: "HH:MM", check_out: "HH:MM" | "", note }.
attendanceServices.createMark = async (payload) => (await jwtAuthAxios.post("/attendance/marks", payload)).data;
attendanceServices.updateMark = async (id, payload) => (await jwtAuthAxios.patch(`/attendance/marks/${id}`, payload)).data;
// { user_id, valid_from: "YYYY-MM-DD", blocks: { "1": [["09:30", "14:00"], ...], ... } }
attendanceServices.saveSchedule = async (payload) => (await jwtAuthAxios.put("/attendance/schedule", payload)).data;

export default attendanceServices;
